module.exports = __webpack_public_path__ + "img/11fc1ac.png";